import { render, staticRenderFns } from "./StaffPage.vue?vue&type=template&id=58eb3f1b&"
import script from "./StaffPage.vue?vue&type=script&lang=js&"
export * from "./StaffPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports